import { Box, styled } from '@mui/material';

export const StyledCitationValueViewerWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  width: '100%',
  height: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  padding: '2px 4px',
}));

export const StyledCitationNumber = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '14px',
  height: '12px',
  fontSize: '0.6rem',
  fontWeight: 600,
  padding: '0 2px',
  borderRadius: '2px',
}));